/* stylelint-disable no-descending-specificity */
@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@use '@helsenorge/designsystem-react/scss/font-settings' as font-settings;
@import '@helsenorge/designsystem-react/scss/breakpoints';

.border {
  border-top: 1px solid palette.$neutral200;
  margin: 0 spacers.getSpacer(s);

  @media (min-width: map.get($grid-breakpoints, md)) {
    margin: 0 spacers.getSpacer(m);
  }

  @media print {
    display: none;
  }
}

.breadcrumb {
  &__content {
    @media (min-width: map.get($grid-breakpoints, md)) {
      padding: spacers.getSpacer(2xs) 0;
    }
  }

  &__label {
    font-size: font-settings.$font-size-sm;
    line-height: font-settings.$lineheight-size-xs;
    font-weight: 600;
    color: palette.$black;
    border-bottom: 1px solid transparent;
    text-decoration: none;

    @media (min-width: map.get($grid-breakpoints, md)) {
      font-size: font-settings.$font-size-md;
      line-height: font-settings.$lineheight-size-sm;
    }
  }

  &__link,
  a.breadcrumb__link {
    display: flex;
    align-items: center;
    border: none;
    text-decoration: none;

    svg {
      margin-left: -0.5rem;
    }

    &:hover,
    &:focus {
      .breadcrumb__label {
        color: palette.$blueberry700;
        border-color: palette.$blueberry700;
      }

      polygon,
      rect {
        fill: palette.$blueberry700;
      }
    }

    &:focus {
      outline: none;
      background-color: transparent;

      .breadcrumb__label {
        background-color: rgba(palette.$blueberry700, 0.1);
      }
    }
  }

  @media print {
    display: none;
  }
}
